module.exports = __webpack_public_path__ + "media/images/emblems/Buochs-coat_of_arms-341174c13222257fb080025006271dd3.svg";